import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="py-16 px-6 lg:px-12 bg-slate-900">
      <div className="max-w-7xl mx-auto">
        {/* Main Footer Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-8 lg:gap-12">
          {/* Brand Column - takes 2 columns on large screens */}
          <div className="col-span-2 sm:col-span-3 lg:col-span-2">
            <img 
              src="/images/gigseasy-logo.svg" 
              alt="GigsEasy Logo" 
              className="h-10 brightness-0 invert mb-4"
            />
            <p className="text-slate-400 text-sm mb-4 max-w-xs">
              Get paid by reading emails and performing simple tasks. Join thousands of earners today.
            </p>
            <p className="text-slate-400 text-sm mb-4">
              <a href="mailto:support@gigseasy.com" className="hover:text-[#00B894] transition-colors">support@gigseasy.com</a>
            </p>
            <p className="text-slate-400 text-sm mb-6">
              <a href="tel:+18667015753" className="hover:text-[#00B894] transition-colors">(866) 701-5753</a>
            </p>
            {/* Social Media Icons */}
            <div className="flex gap-4">
              <a 
                href="https://www.facebook.com/gigseasy" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center text-slate-400 hover:bg-[#00B894] hover:text-white transition-all"
                aria-label="Facebook"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                </svg>
              </a>
              <a 
                href="https://www.linkedin.com/company/gigseasy" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center text-slate-400 hover:bg-[#0077B5] hover:text-white transition-all"
                aria-label="LinkedIn"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>
          
          {/* Legal Column */}
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">Legal</h4>
            <ul className="space-y-3">
              <li><Link to="/terms-of-use" className="text-slate-400 hover:text-[#00B894] transition-colors text-sm">Terms Of Use</Link></li>
              <li><Link to="/privacy-policy" className="text-slate-400 hover:text-[#00B894] transition-colors text-sm">Privacy Policy</Link></li>
              <li><Link to="/california-privacy" className="text-slate-400 hover:text-[#00B894] transition-colors text-sm">California Privacy</Link></li>
              <li><Link to="/sms-terms" className="text-slate-400 hover:text-[#00B894] transition-colors text-sm">SMS Terms</Link></li>
              <li><Link to="/cookie-declaration" className="text-slate-400 hover:text-[#00B894] transition-colors text-sm">Cookie Declaration</Link></li>
            </ul>
          </div>
          
          {/* Company Column */}
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">Company</h4>
            <ul className="space-y-3">
              <li><Link to="/about-us" className="text-slate-400 hover:text-[#00B894] transition-colors text-sm">About Us</Link></li>
              <li><Link to="/contact-us" className="text-slate-400 hover:text-[#00B894] transition-colors text-sm">Contact Us</Link></li>
              <li><Link to="/advertise" className="text-slate-400 hover:text-[#00B894] transition-colors text-sm">Advertise</Link></li>
              <li><Link to="/blog" className="text-slate-400 hover:text-[#00B894] transition-colors text-sm">Blog</Link></li>
            </ul>
          </div>
          
          {/* Resources Column */}
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">Resources</h4>
            <ul className="space-y-3">
              <li><Link to="/how-to-earn" className="text-slate-400 hover:text-[#00B894] transition-colors text-sm">How to Earn</Link></li>
              <li><Link to="/maximize-earnings" className="text-slate-400 hover:text-[#00B894] transition-colors text-sm">Maximize Earnings</Link></li>
              <li><Link to="/points-payments" className="text-slate-400 hover:text-[#00B894] transition-colors text-sm">Points & Payments</Link></li>
              <li><Link to="/faq" className="text-slate-400 hover:text-[#00B894] transition-colors text-sm">FAQ</Link></li>
            </ul>
          </div>
          
          {/* Trust & Safety Column */}
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">Trust & Safety</h4>
            <ul className="space-y-3">
              <li><Link to="/data-security" className="text-slate-400 hover:text-[#00B894] transition-colors text-sm">Data Security</Link></li>
              <li><Link to="/fraud-prevention" className="text-slate-400 hover:text-[#00B894] transition-colors text-sm">Fraud Prevention</Link></li>
              <li><Link to="/register" className="text-slate-400 hover:text-[#00B894] transition-colors text-sm">Create Account</Link></li>
              <li><Link to="/login" className="text-slate-400 hover:text-[#00B894] transition-colors text-sm">Sign In</Link></li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              © 2026 GigsEasy.com. All rights reserved. Active Consumers LLC.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/terms-of-use" className="text-slate-500 hover:text-slate-300 text-xs">Terms</Link>
              <Link to="/privacy-policy" className="text-slate-500 hover:text-slate-300 text-xs">Privacy</Link>
              <Link to="/sms-terms" className="text-slate-500 hover:text-slate-300 text-xs">SMS</Link>
              <Link to="/cookie-declaration" className="text-slate-500 hover:text-slate-300 text-xs">Cookies</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
